import {db} from '@/plugins/firebase';
import Vue from 'vue';
import Recorded from "@/Lib/Recorded";
import moment from 'moment';
import firebase from "firebase/app";
import 'firebase/firestore';
export default {
    namespaced: true,
    state: {
        loading: false,
        samplesProcessing: {},
        samplesFailed: {},
        sampleQueuedLocally: {},
        samplesProcessed: {},
        samplesAwaitingEmail: {},
        listeners: {},
        samplesReadyForRelease: {},
        customersWaitingForRelease: {},
    },
    actions: {
        async listenToProcessing({state}){
            state.listeners.processingListener = db.collection('release_sample').where('process_status.state', 'in', ['processing', 'failed']).onSnapshot(snap => {
                snap.docChanges().forEach(change => {
                    const sample = change.doc.data();
                    const uuid = change.doc.id;
                    if(change.type === 'added'){
                        if(sample.process_status.state === 'processing'){
                            console.log('samplesProcessing')
                            Vue.set(state.samplesProcessing, uuid, sample);
                        }else{
                            Vue.set(state.samplesFailed, uuid, sample);
                        }
                    }
                    if(change.type === 'modified'){
                        if(sample.process_status.state === 'processing'){
                            console.log('samplesProcessing update')
                            // remove from failed if exists
                            if(uuid in state.samplesFailed){
                                Vue.delete(state.samplesFailed, uuid);
                            }
                            // remove from done if exists
                            if(uuid in state.samplesProcessed){
                                Vue.delete(state.samplesProcessed, uuid);
                            }
                            Vue.set(state.samplesProcessing, uuid, sample);
                        }else{
                            //remove from processing if exists
                            if(uuid in state.samplesProcessing){
                                Vue.delete(state.samplesProcessing, uuid);
                            }
                            Vue.set(state.samplesFailed, uuid, sample);
                        }
                    }
                    if(change.type === 'removed'){
                        if(sample.process_status.state === 'processing'){
                            Vue.delete(state.samplesProcessing, uuid);
                        }else{
                            Vue.delete(state.samplesFailed, uuid);
                        }
                    }
                })
            })
        },
        async listenToDone({state}){
            state.listeners.doneListener = db.collection('release_sample')
                .where('process_status.state', '==', 'done')
                .orderBy('process_status.updated_at', 'desc')
                .limit(1)
                .onSnapshot(snap => {
                    snap.docChanges().forEach(change => {
                        const sample = change.doc.data();
                        const uuid = change.doc.id;
                        if(change.type === 'added'){
                            Vue.set(state.samplesProcessed, uuid, sample);
                        }
                        if(change.type === 'modified'){
                            // remove from processing if exists
                            if(uuid in state.samplesProcessing){
                                Vue.delete(state.samplesProcessing, uuid);
                            }
                            // remove from failed if exists
                            if(uuid in state.samplesFailed){
                                Vue.delete(state.samplesFailed, uuid);
                            }
                            Vue.set(state.samplesProcessed, uuid, sample);
                        }
                        // if(change.type === 'removed'){
                        //     state.samplesProcessed.delete(uuid);
                        // }
                    });
            });
        },
        async listenForEmailNotSent({state}){
            state.listeners.emailSentListener = db.collection('release_sample')
                .where('email_sent', '==', false)
                .onSnapshot(snap => {
                    snap.docChanges().forEach(change => {
                        const sample = change.doc.data();
                        const uuid = change.doc.id;
                        if(change.type === 'added'){
                            Vue.set(state.samplesAwaitingEmail, uuid, sample);
                        }
                        if(change.type === 'modified'){
                            Vue.set(state.samplesAwaitingEmail, uuid, sample);
                        }
                        if(change.type === 'removed'){
                            Vue.delete(state.samplesAwaitingEmail, uuid);
                        }
                    });
            });

        },
        // async getSamplesReadyForRelease({state}){
        //     const query = await Recorded.get('/query', {
        //         table: 'samples',
        //         select: ['*'],
        //         orderBy: {id: 'asc'},
        //         where: [
        //             {
        //                 column: 'id',
        //                 operator: 'in',
        //                 value: [
        //                     'WA-250129-085',
        //                     'WA-250129-084',
        //                     'WA-250129-083',
        //                     'WA-250129-082',
        //                     'WA-250129-081',
        //                     'WA-250129-080',
        //                 ]}
        //         ],
        //         with: [
        //             {
        //                 table: 'sample_cert_types',
        //                 name: 'sample_cert_type',
        //                 select: ['uuid', 'name', 'description'],
        //                 localKey: 'sample_cert_type_uuid',
        //                 foreignKey: 'uuid',
        //                 firstResult: true,
        //             },
        //             {
        //                 table: 'sample_flags',
        //                 select: ['*'],
        //                 localKey: 'uuid',
        //                 foreignKey: 'sample_uuid',
        //             },
        //             {
        //                 table: 'sample_notes',
        //                 select: ['*'],
        //                 localKey: 'uuid',
        //                 foreignKey: 'sample_uuid',
        //                 with: [
        //                     {
        //                         table: 'sample_note_types',
        //                         name: 'note_type',
        //                         select: ['uuid', 'name'],
        //                         localKey: 'sample_note_type_uuid',
        //                         foreignKey: 'uuid',
        //                     }
        //                 ]
        //             }
        //         ]
        //     });
        //     query.data.forEach(sample => {
        //         if(!state.samplesReadyForRelease[sample.customer_id]){
        //             state.samplesReadyForRelease[sample.customer_id] = [];
        //         }
        //         state.samplesReadyForRelease[sample.customer_id].push(sample);
        //     })
        // },
        async releaseSample({state, rootState, dispatch}, sample_uuid){
            // if(state.samplesProcessing[sample_uuid]) return;
            if(!await dispatch('hasSampleBeenWaiting', sample_uuid))return;
            await db.collection('release_sample').doc(sample_uuid).set({
                cert_generated: false,
                is_ready: false,
                is_ready_v2: true,
                sample_uuid: sample_uuid,
                process_status: {
                    state: 'processing',
                    message: 'Queueing for release',
                    updated_at: firebase.firestore.FieldValue.serverTimestamp()
                }
            },{merge: true})
            const log =  await dispatch('generateReleaseAttemptLog', {sample_uuid})
            await db.collection('conan_logs').doc().set(log);
        },
        async releaseSomeSamples({state, rootState, dispatch}, sample_uuids){
            const batch = db.batch();
            const collectionRef = db.collection('release_sample');
            const logCollectionRef = db.collection('conan_logs');
            for(let i = 0; i < sample_uuids.length; i+=1){
                const sample_uuid = sample_uuids[i];
                if(!await dispatch('hasSampleBeenWaiting', sample_uuid)) continue;
                const docRef = collectionRef.doc(sample_uuid);
                batch.set(docRef, {
                    cert_generated: false,
                    is_ready: false,
                    is_ready_v2: true,
                    sample_uuid: sample_uuid,
                    process_status: {
                        state: 'processing',
                        message: 'Queueing for release',
                        updated_at: firebase.firestore.FieldValue.serverTimestamp()
                    }
                }, {merge: true});
                const log = await dispatch('generateReleaseAttemptLog', {sample_uuid})
                const logDocRef = logCollectionRef.doc();
                batch.set(logDocRef, log);
            }
            await batch.commit();
        },
        async hasSampleBeenWaiting({state}, sample_uuid){
            // if sample exists in processing and process_status.updated_at is a minute or more than now
            // then return true;
            // if sample does not exist in processing return true
            // if sample exists in processing and process_status.updated_at is less than a minute from now
            // then return false;
            if(sample_uuid in state.samplesProcessing){
                const sample = state.samplesProcessing[sample_uuid];
                const updated_at = sample.process_status.updated_at;
                const now = moment().utc();
                const diff = now.diff(moment(updated_at.toDate()), 'minutes');
                if(diff >= 1){
                    return true;
                }else{
                    return false;
                }
            }
            return true;
        },
        async generateReleaseAttemptLog({rootState}, {type = "Release", sample_uuid}){
            let message = "Release Attempted";
            if(type === "amendment"){
                message = "Amendment Release Attempted";
            }
            // await db.collection('conan_logs').doc().set();
            return {
                uuid: sample_uuid,
                action: "RELEASE",
                timestamp: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
                model: "sample",
                request_type: "Firestore update: release_sample",
                request_uri: "Firestore Release Queue",
                diff: {
                    display_text: message,
                    from_display_text: null,
                    from_value: null,
                    key: null,
                    value: null
                },
                location: window.location.href,
                user_id: rootState.user.id,
                user_name: rootState.user.name,
            }
        },
        resetDataAndStopListeners({state}){
            if(state.listeners.processingListener){
                state.listeners.processingListener();
                state.listeners.processingListener = null;
            }
            if(state.listeners.doneListener){
                state.listeners.doneListener();
                state.listeners.doneListener = null;
            }
            if(state.listeners.emailSentListener){
                state.listeners.emailSentListener();
                state.listeners.emailSentListener = null;
            }
            state.loading = false,
            state.samplesProcessing = {}
            state.samplesFailed = {}
            state.sampleQueuedLocally = {}
            state.samplesProcessed = {}
            state.samplesAwaitingEmail = {}
            state.listeners = {}
        },
        async deleteQueuedSample({state}, sample_uuid){
            await db.collection('release_sample').doc(sample_uuid).delete();
            if(sample_uuid in state.samplesProcessing){
                Vue.delete(state.samplesProcessing, sample_uuid);
            }
            if(sample_uuid in state.samplesFailed){
                Vue.delete(state.samplesFailed, sample_uuid);
            }
            if(sample_uuid in state.samplesProcessed){
                Vue.delete(state.samplesProcessed, sample_uuid);
            }
        }
    }
}
